export type MotionEase = (value: number) => number;

const linear: MotionEase = (value) => value;
const power1Out: MotionEase = (value) => 1 - (1 - value) ** 2;
const power1InOut: MotionEase = (value) =>
  value < 0.5 ? 2 * value ** 2 : 1 - (-2 * value + 2) ** 2 / 2;
const power2Out: MotionEase = (value) => 1 - (1 - value) ** 3;
const power2InOut: MotionEase = (value) =>
  value < 0.5 ? 4 * value ** 3 : 1 - (-2 * value + 2) ** 3 / 2;
const power4Out: MotionEase = (value) => 1 - (1 - value) ** 5;
const power4InOut: MotionEase = (value) =>
  value < 0.5 ? 16 * value ** 5 : 1 - (-2 * value + 2) ** 5 / 2;

const EASING_MAP: Record<string, MotionEase> = {
  none: linear,
  linear,
  'power1.inOut': power1InOut,
  'power1.out': power1Out,
  'Power1.easeOut': power1Out,
  'power2.inOut': power2InOut,
  'power2.out': power2Out,
  'power4.easeOut': power4Out,
  'power4.inOut': power4InOut,
  'power4.out': power4Out,
};

export default function resolveMotionEase(ease: string): MotionEase {
  return EASING_MAP[ease] ?? power1InOut;
}
